import React, { useState, useEffect } from 'react';
import Navbar from './navbar.js';
import Remote from './Remote.js';
import RemoteTabs from './Tab.js'
import db from './firebase.config.js';
import './main.css'

function DefaultLookup({ match }) {
    const uid = 'TyLhISupE7SFuRxhiqaVx7ofeUF2';

    const [name, setName] = useState('')
    const [status, setUserStatus] = useState(false)
    useEffect(() => {
        const status_interval = setInterval(() => (db.collection('Users').doc(uid).get()
          .then(snapshot => {
            const data = snapshot.data();
            if(data){
                setUserStatus(data.isSessionActive);
                setName(data.fullName);
            }
          }).catch(err => {
            console.log("DefaultLookup fetch error:", err);
          }))
          , 10000);


        return () => {
          clearInterval(status_interval);
        };
      }, [status]);

    return (
        <div className='dark-container'>
            <Navbar uid={uid} qr_id={"qr_id"} active={status} driver_name={name} passenger={"passenger_id"}/>
            <Remote />
        </div>

    );
}

export default DefaultLookup;
